// Components
import DropdownInput from "components/inputs/dropdown"
import { ComparisonReport_s } from "components/property/reports/report-styles"
import comparisonService from "data/comparison"
import { local } from 'data/lib/local-json'
// Data
import propertyReportService from "data/reports-property"
import _ from 'lodash'
import calcService from "data/calc"
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { FormError_s } from "styles/form-styles"
import { ReportForm_s } from "styles/report-styles"

interface TenantRosterComparisonProps {
  property: object
}

const TenantRosterComparison: FC<TenantRosterComparisonProps> = (props) => {
  const [comparisons, setComparisons]               = useState<any>(null)
  const [comparison, setComparison]                 = useState<any>(null)
  const [propertyComparison, setPropertyComparison] = useState<object|null>(null)

  useEffect(() => {
    const property = JSON.parse(JSON.stringify(props['property']))
    if (comparison && propertyComparison?.['sourcepropertyid'] !== property['propertyid'] && property['assetid']){
      getPropertyComparison(comparison, property['assetid'])
    }
  }, [props['property']])

  useEffect(() => {
    const currentFolder = _.last(local('folderPath'))

    const comparisonSubscription = comparisonService.stream().subscribe((data) => {
      if (data.state == 'ok') {
        setComparisons(data.value)
        if (!comparison && data.value.length > 0){
          let comparison = data.value[0]
          setComparison(JSON.parse(JSON.stringify(comparison)))
        }
      }
    })

    comparisonService.fetchComparisonsByFolderId(currentFolder)

    return function cleanup() {
      comparisonSubscription.unsubscribe()
    }

  }, [])

  useEffect(() => { 
    if (comparison){
      const assetid = props['property']['assetid'];
      if (assetid && comparison){
        getPropertyComparison(comparison, assetid)
      }
    }         
  }, [comparison])

  function getPropertyComparison(comparison:any, assetid:number){
    let comparisonid = typeof(comparison) === 'object' ? comparison['comparisonid'] : comparison
    comparisonService.findPropertyComparison(comparisonid, assetid).then((propertyComparison) => {
      if (propertyComparison){
        setPropertyComparison(propertyComparison)
      }
    })
  }

  function submit():void {
    let compObj = typeof(comparison) === 'object' ? comparison : _.find(comparisons, {comparisonid: comparison})
    propertyReportService.propertyReport({
      report: 'tenant_roster_comparison',
      params: {
        comparison: {
          comparison_propertyid: propertyComparison?.['comparisonpropertyid'],
          comparison_code: compObj['code'],
        }
      }
    });
  }

  const disabled = !calcService.calcCheck(props.property) || propertyComparison?.['status'] === 'missing_calc' || propertyComparison?.['status'] === 'property_not_found'
  const missingCalc1 = !calcService.calcCheck(props.property)
  const missingCalc2 = propertyComparison?.['status'] === 'missing_calc'
  const propNotFound = propertyComparison?.['status'] === 'property_not_found'

  return (
    <ComparisonReport_s>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>Run Report</ButtonWithPress_s>
      <ReportForm_s>
        { missingCalc1 && <FormError_s style={{marginRight: '5px'}}>Current property is not calculated</FormError_s> }
        { missingCalc2 && <FormError_s style={{marginRight: '5px'}}>Comparison property is not calculated</FormError_s> }
        { propNotFound && <FormError_s>Property not found for comparison</FormError_s> }
      </ReportForm_s>
      <ReportForm_s>
        <div>
          <Label_s>Comparison</Label_s>
          <DropdownInput
            className="comparison-input"
            persist={(field:string, val:string)=>setComparison(val)}
            field="comparison"
            options={comparisons?.map(comparison => { return {'label': `${comparison['code']}`, 'value': comparison['comparisonid']}})}
            value={comparison}
          />
        </div>
      </ReportForm_s>
    </ComparisonReport_s> )
}

export default TenantRosterComparison
